module.exports = __webpack_public_path__ + "img/pay1.9f97f36c.png";